import { useState } from 'react'
import Canales from './canales.json'
import Pills from './Pills'

const SectionCanales = () => {
  const [state, setState] = useState({
    activedCategory: { id: 0, name: 'Todas' },
    searchValue: ''
  })
  const { activedCategory, searchValue } = state

  const updateSearch = (e) => {
    setState({
      ...state,
      searchValue: e.target.value
    })
  }

  const updateCategory = (selCategory) => {
    setState({
      ...state,
      activedCategory: selCategory
    })
  }

  const filteredChannels = Canales.filter((canal, i) => {
    const search = canal.nombre.toLowerCase().includes(state.searchValue.toLocaleLowerCase())
    if ((searchValue && search) || (!searchValue && (state.activedCategory.name === canal.categoria || state.activedCategory.id === 0))) return canal
    return false
  })

  return (
    <>
      <section className="sectionCanales">
        <div className="wrap canales"> 
          <div className="shadow-controllers"></div>
          <div className="container-controllers">
            <div className="searchForm">
              <input type="text" placeholder="Buscar canal" value={searchValue} onChange={(e) => updateSearch(e)} />
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M12.1763 10.9637L16.7491 15.5365C16.9098 15.6973 17.0001 15.9154 17 16.1428C16.9999 16.3702 16.9095 16.5882 16.7487 16.7489C16.5878 16.9096 16.3697 16.9999 16.1424 16.9998C15.915 16.9997 15.6969 16.9093 15.5362 16.7485L10.9634 12.1757C9.59644 13.2345 7.87745 13.7327 6.15615 13.5691C4.43486 13.4055 2.84055 12.5922 1.69756 11.2948C0.554579 9.99743 -0.0512229 8.31333 0.00339672 6.58513C0.0580164 4.85694 0.768955 3.21446 1.99158 1.99183C3.21421 0.769199 4.85669 0.0582605 6.58489 0.00364086C8.31309 -0.0509788 9.99718 0.554824 11.2946 1.69781C12.592 2.84079 13.4052 4.4351 13.5688 6.1564C13.7325 7.8777 13.2342 9.59669 12.1755 10.9637H12.1763ZM6.80032 11.8995C8.15286 11.8995 9.45 11.3622 10.4064 10.4058C11.3628 9.4494 11.9001 8.15225 11.9001 6.79971C11.9001 5.44717 11.3628 4.15002 10.4064 3.19363C9.45 2.23724 8.15286 1.69995 6.80032 1.69995C5.44777 1.69995 4.15063 2.23724 3.19424 3.19363C2.23785 4.15002 1.70055 5.44717 1.70055 6.79971C1.70055 8.15225 2.23785 9.4494 3.19424 10.4058C4.15063 11.3622 5.44777 11.8995 6.80032 11.8995Z" fill="url(#paint0_linear_355_159)"/>
                <defs>
                  <linearGradient id="paint0_linear_355_159" x1="0" y1="0.000244141" x2="16.9144" y2="0.26842" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#92F23B"/>
                  <stop offset="1" stopColor="#B0FDFF"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <Pills activedCategory={activedCategory} updateCategory={updateCategory} searchValue={searchValue} />
          </div>

          <section className="canales-contenedor">
            <div className="grid-canales">
              {filteredChannels.map((canal, i) => {
                return (
                  <article className='canal' key={`channels-${i}`}>
                    <figure>
                      <div className={`img-container ${canal.theme === 2 && 'black'}`}>
                        <img src={canal.imagen} />
                      </div>
                    </figure>
                    <span>{canal.canal}</span>
                  </article>
                  );
              })}
            </div>
            {filteredChannels.length === 0 && searchValue &&
              <div className="wrong-search">
                <p className="icon-text">😕</p>
                <p className="white-text">Ups! No encontramos resultados para </p>
                <p className="secondary-text">("{state.searchValue}")</p>
              </div>
            }
          </section>
          </div>
        </section> 
    </>
  )
}
    
    export default SectionCanales;